import React, { Component } from "react";
import { connect } from 'react-redux';
import { ceTogglePack } from "../../../redux/actions/checkout_operations";
import lpApp from '../../../app/lp_app';
import lpevents from "../../../tracking/lpevents";
import writeHistory from '../../../logic/history'

class UpsellEcCardComponent extends Component {
  goToNextStep = () => {
    this.props.togglePack(true)
    lpevents.trackDatalayerMixpanel("Je suis intéressé", "upsellScreenEC")
    if (typeof (window.sendinblue) !== 'undefined') {
      window.sendinblue.identify(
        lpApp.getState().account_settings.mail,
        {EXPERT_COMPTABLE: true}
      );
    }
  }

  goBackToPackSelectorPage = () => {
    lpevents.trackDatalayerMixpanel("Je m’occupe seul de ma comptabilité", "upsellScreenEC")
    writeHistory('payment', false, false, lpApp.contractUniqid)
  }
  
  render (){
    const {monthSubscription,yearSubscription,textBtn,textLink} = this.props.card
    return(
      <div className="upsellEc-content-card">
        <p className="upsellEc-content-card-text">{monthSubscription} <br/> {yearSubscription}</p>
        <button type="button" className="upsellEc-interested-btn" onClick={this.goToNextStep}>{textBtn}</button>
        <button type="button" className="upsellEc-desinterested-btn" onClick={this.goBackToPackSelectorPage}>{textLink}</button>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  togglePack: (val) => {
    dispatch(ceTogglePack(val));
  }
});

const UpsellEcCard = connect(null, mapDispatchToProps)(UpsellEcCardComponent);

export default UpsellEcCard;



// WEBPACK FOOTER //
// ./src/components/buy/Upsell-EC/upsell-Ec-Card.js